import React from "react";

interface ITag {
    tags: string[]
    className?: string
}

const Tag = ({
    tags,
    className
}: ITag) => {
    return (
        tags.map((name: string, index) => <span className={`m-tags__tag -title ${className}`} key={index}>{name}</span>)
    )
}

export default Tag;